export const NAMESPACE = "@seriously-rad/seriouslyrad-demo/";